import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from '../../services/message.service';
import { IMessage } from '../../models/message';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html'
})
export class MessagesComponent implements OnInit {

  /**
   * Auto-dismiss timeout in milliseconds
   *
   * @type {number}
   * @memberof MessageComponent
   */
  @Input() timeout = 0;

  /**
   * Current messages to display
   *
   * @type {IMessage[]}
   * @memberof MessagesComponent
   */
  messages: IMessage[] = [];

  constructor(private messageService: MessageService) {
  }

  ngOnInit() {
    this.messageService.messages.subscribe((x: IMessage[]) => {
      this.messages = [];
      x.forEach(msg => this.messages.push(msg));
    });
  }

  /**
   * Handle click on dismiss button
   *
   * @param {string} id
   * @memberof MessagesComponent
   */
  onDismissMessage(id: string) {
    this.messageService.remove(id);
  }

}
